import React, { useState } from 'react';
import { Button } from '../../Button';
export const FooterButton = (props) => {
    const { onClick, onClose } = props;
    const [loading, setLoading] = useState(false);
    const handleClick = (e) => {
        const returnValue = onClick?.(e);
        if (Object.prototype.toString.call(returnValue) === '[object Promise]') {
            setLoading(true);
            returnValue
                ?.then(() => {
                setLoading(false);
                onClose?.(e);
            })
                .catch((err) => {
                setLoading(false);
                console.error(err);
            });
        }
        else {
            onClose?.(e);
        }
    };
    return (React.createElement(Button, { ...props, loading: loading, disabled: loading, onClick: handleClick }));
};
